import { render, staticRenderFns } from "./ViaEmilia.vue?vue&type=template&id=5f711d48"
import script from "./ViaEmilia.vue?vue&type=script&lang=js"
export * from "./ViaEmilia.vue?vue&type=script&lang=js"
import style0 from "./ViaEmilia.vue?vue&type=style&index=0&id=5f711d48&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports